import React, { Component } from 'react';
import logo from '../logo.png';


function SplashMessage() {
    const containerStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh', // Adjust as needed
      };
    
      const centeredDivStyle = {
        textAlign: 'center', // Center text horizontally
        padding: '20px', // Add padding for better visibility
      };
    return (
        <div style={containerStyle}>
            <img src={logo} className="App-logo" alt="logo" style={centeredDivStyle} />
        </div>
    );
}

export default function withSplashScreen(WrappedComponent) {
    return class extends Component {
        constructor(props) {
            super(props);
            this.state = {
                loading: true,
            };
        }

        async componentDidMount() {
            try {
                // Put here your await requests/ API requests
                setTimeout(() => {
                    this.setState({
                        loading: false,
                    });
                }, 2000)
            } catch (err) {
                console.log(err);
                this.setState({
                    loading: false,
                });
            }
        }

        render() {
            // while checking user session, show "loading" message
            if (this.state.loading) return SplashMessage();

            // otherwise, show the desired route
            return <WrappedComponent {...this.props} />;
        }
    };
}